<template>
    <div class="w-100" style=" border-radius: 15px; border: 1px solid #E3E3E3;">
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
       <div class="text-center" style="font-size: .8em;">
       </div>

       <div class="d-flex justify-content-between align-items-center row pl-3 pr-3 pt-1 pb-1 w-100">
           <div class="d-flex col-2 justify-content-start align-items-center mt-2 mb-1" style="border-right: 2px solid #E6E6E6;">
               <em class="diente_outline" style="width: 1.5em;"></em>
               <div style="font-weight: 500;">
                   <p class="mt-3 ml-3" v-if="diente.diente.diente.length<= 2"> OD {{ diente.diente.diente }}</p>
                   <p class="mt-3 ml-3" v-else>{{ diente.diente.diente }}</p>
               </div>
           </div>

           <div class="col-6">
               <div class="" style="min-height: 50px;">
                 <p class="text-left statePadecimiento p-0" style="font-weight: 500; font-size: .9em; padding: 0px;">{{ diente.padecimiento.descripcion }}</p>
                <div class="p-0">
                    <div class="text-left p-0" style="font-size: .7em;">{{ diente.padecimiento.idClasificacionClinica == 1 ? 'Prioridad clínica' : 'Hallazgos adicionales' }}</div>
                </div>
               </div>
           </div>
           <div class="col-3 text-right p-0" style="font-size: .7em;">
             <span>{{ diente.tratamientos[0].length }} tratamiento(s) agregados </span> <span v-if="segundaOpcionCreada">Opción 1</span>
             <br>
             <span v-if="segundaOpcionCreada">{{ diente.tratamientos[1].length }} tratamiento(s) agregados Opción 2</span>
           </div>
           <div class="col-1">
               <b-button v-if="diente.visible" class="ml-3" size="sm" variant="link"
                   @click="cambiarVisibilidad()"
               >
               <em class="chevron_obscuro" style="width: .9em; transform: rotate(180deg);"></em>
               </b-button>
               <b-button v-if="!diente.visible && diente.padecimiento != null"  class="ml-3" size="sm" variant="link" @click="cambiarVisibilidad()" >
                    <em class="chevron_obscuro" style="width: .9em;"></em>
               </b-button>
              
           </div>
       </div>

       <b-collapse class="mt-4 pl-3 pr-3" :visible="diente.visible" :id="'collapse-'+index" style="min-height: 100px;">
           <div class="d-flex justify-content-end" v-if="diente.padecimiento !== null" style="width: 100%">
               
               <div class="d-flex justify-content-end align-items-center" style="width: 400px;">
                   <div class="d-flex justify-content-center align-items-center pl-3 pr-3" style="height: 2.5em;"
                       @click="opcionTabSeleccionada = index"
                       :class="opcionTabSeleccionada == index ? 'tabOpciones seleccionado' : 'tabOpciones'"
                       v-for="(opt, index) in opciones" :key="index" :title="opt.nombre">
                       <p class="mt-3" :class="opcionTabSeleccionada == index ? 'tabTxtSeleccionado' : 'tabTxt'">
                           {{ opt.nombre }} 
                       </p>
                   </div>
               </div>
           </div>

           <b-col cols="12" v-if="opcionTabSeleccionada === 1">
               <div class="mt-3" fluid  style="font-size: .85em;">
                  <p class="text-left" style="font-weight: 600; color: #5A5A5A;">Padecimientos adicionales al OD {{ diente.diente.diente }}</p>
       
                   <div v-if="padecimientosAdicionalesNoReq !== undefined && padecimientosAdicionalesNoReq !== null">
              
                        <ul class="text-left" style="font-weight: .8;">
                            <li style="list-style: initial !important;" v-for="(padecimiento, idx) in padecimientosAdicionalesNoReq" v-bind:key="diente.diente + '-' + idx">
                                {{ padecimiento.descripcion }}
                            </li>
                        </ul>
                   </div>

                   <b-row>
                       <b-col cols="3"></b-col>
                       <b-col style="text-align: center">
                           <span v-if="padecimientosAdicionalesNoReq === undefined
                               || padecimientosAdicionalesNoReq === null
                               || padecimientosAdicionalesNoReq.length ===0">
                               Sin padecimientos adicionales
                           </span>
                       </b-col>
                       <b-col cols="3"></b-col>
                   </b-row>
               </div>
           </b-col>
           <b-row v-if="diente.padecimiento != null && opcionTabSeleccionada === 0" class="mt-3">
               <b-col v-for="(lista,i) in diente.tratamientos" :key=" diente.diente.diente + 'tx'+i">
                   <HDTratamientosViewOnly
                       :segundaOpcionCreada="segundaOpcionCreada"
                       :contraerCard="contraerCard"
                       :disable="disable"
                       :clasificacion="diente.padecimiento.clasificacion"
                       :tratamientos="lista"
                       :index="i"
                       :indexTarjeta="index"
                       @cambiarPaquete="cambiarPaquete"
                       @padecimientoModificado="padecimientoModificado">
                   </HDTratamientosViewOnly>
               </b-col>
           </b-row>
       </b-collapse>
   </div>
 </template>
 
 <script>
 import {CatalogosService} from "@/apiServices/catalogos/CatalogosService";
 import HDTratamientosViewOnly from "./HDTratamientosViewOnly.vue";
 
 export default {
   name: "HDPadecimientosViewOnly",
   components: {
    HDTratamientosViewOnly,
   },
   props: {
       contraerCard: Boolean,
       statePadecimiento: null,
       statePadecimientoAdicional: null,
       stateValidate: null,
       disable: {
           type: Boolean,
           default: false
       },
       diente: Object,
       idPaciente: Number,
       idEmpleado: Number,
       index: null,
       segundaOpcionCreada: Boolean,
       ordenar: Boolean,
   },
   data: () => {
       return {
         version: process.env.VUE_APP_ENV_VERSION,
         debug: false,
           auxiliar: 0,
           opcionTabSeleccionada: 0,
           opciones: [
               {nombre: "Tratamientos"},
               {nombre: "Padecimientos"},
           ],
           padecimientos: [],
           padecimientosAdicionalesNoReq: [],
           catalogosServicios: new CatalogosService(),
           listaDientes: [],
           esconder: false,
           seccPadAd: 1,
       }
   },
   mounted() {
     if(this.segundaOpcionCreada === false){
       this.diente.tratamientos.splice(1, 1);
     }
     if (this.diente.padecimientosAdicionalesNoReq != undefined && this.diente.padecimientosAdicionalesNoReq != null) {
       this.padecimientosAdicionalesNoReq = this.diente.padecimientosAdicionalesNoReq;
     }

   },
   created() {
     this.debug = this.$localStorageService.getDebug();
   },
   watch: {
       "diente.visible": function(){
       },
       auxiliar(newVal) {
           if(this.diente.padecimiento == null){
               let objetoBuscado = this.padecimientos.find(objeto => objeto.idPadecimiento == newVal);
               this.diente.padecimiento = objetoBuscado;
           }   
           
       },
     "diente.padecimientoAux": function () {
       let objetoBuscado = this.padecimientos.find(objeto => objeto.idPadecimiento === this.diente.padecimientoAux);
       this.diente.padecimiento = objetoBuscado
     }
   },
   methods: {
       cambiarVisibilidad(){
           this.diente.visible = !this.diente.visible;
           this.$emit('cambiarVisibilidad')
       },
       cambiarPaquete(index, paquete) {
           this.diente.tratamientos = this.diente.tratamientos.map((l, i) => {
               if (i === index) {
                   l = paquete;
                   l.forEach(element => {
                       element.modificado = true;
                   });
               }
               return l
           })
           this.diente.padecimiento.modificado = true;
       },
       padecimientoModificado(){
        this.diente.padecimiento.modificado = true;
       },
       pestaniaTratamientos(numPestania){
           this.seccPadAd = numPestania
           if(this.diente.tratamientos.length == 0){
               this.diente.tratamientos.push([])
           }
       },
       eliminarDiente() {
           this.$emit('eliminarDiente', this.diente)
       },
 
       agregarPadecimientoAdicional() {
           if (this.padecimientosAdicionalesNoReq === undefined || this.padecimientosAdicionalesNoReq === null) {
               this.padecimientosAdicionalesNoReq = [{
                   "pad": null
               }];
           } else {
               this.padecimientosAdicionalesNoReq.push({
                   "pad": null
               });
           }
           this.actualizarPadecimientosAdds();
       },
   
       submitf(e) {
           e.prevent.default();
       },
   
       quitarPadecimientoAdicional(idx) {
           this.padecimientosAdicionalesNoReq.splice(idx, 1);
           this.actualizarPadecimientosAdds();
       },
   
       actualizarPadecimientosAdds() {
           this.$refs.ads.checkValidity();
           this.$emit('actualizarPadsAddNoReq', {
               idDiente: this.diente.diente.idDiente,
               pads: JSON.parse(JSON.stringify(this.padecimientosAdicionalesNoReq))
           });
       },
   
       cambioPadecimiento(){
           //padecimiento.cambio = true;
           this.ordenar = false;
           this.diente.padecimiento.modificado = false;
           this.$emit('cambioPadecimiento');
       }
   }
 }
 </script>
 
 <style scoped>
 .tabTxtSeleccionado {
   font-size: 0.9vw;
   color: #17a2b8;
   width: 100%;
   }

   .tabTxt {
   font-size: 0.9vw;
   color: #717171;
   }

   .tabOpciones.seleccionado {
   border-style: solid;
   border-width: 1px;
   border-color: #90d3dd;
   border-radius: 10px;
   color: #17a2b8;
   }

   .tabOpciones:hover {
   font-weight: 600;
   }
   .tituloSugerencia{
       font-weight: bold;
       font-style: italic;
       color: #3C3C3C !important;
   }

   .select{
   border: none !important;
   border-bottom: 2px solid #90D3DD !important;
   box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
 }

 .select:focus{
   border: none !important;
   box-shadow: 0px 1px 4px 0px #90D3DD;
 }

 .esconder[aria-expanded="true"] {
   display: none;
 }
 
 .esconder[aria-expanded="false"] {
   display: initial;
 }
 
 .mostrar[aria-expanded="true"] {
   display: initial;
 }
 

 
 .descripcionDiente {
   margin-right: 1rem;
   border-right: solid 1px #c7c7c7
 }
 
 </style>
